module.exports = __webpack_public_path__ + "static/Averta-Regular-de8cbdde34e8ff30959bd35d781fa91c.woff2";